'use strict';

import { getLoginRequiredResolveObj } from "../shared/utils/angularUtils";
import { NAVIGATION_ICON } from '../shared/constants/system/navigationIcons';
import { VIDEO_PAGE } from './constants/videoPage';

export const guidesAndAdditionalInfoModule = angular
  .module('app.guidesAndAdditionalInfo', [])
  .config(guidesAndAdditionalInfoConfig);

guidesAndAdditionalInfoConfig.$inject = ['$routeProvider'];

function guidesAndAdditionalInfoConfig($routeProvider) {
  $routeProvider
    .when('/resources', {
      template: `<ngz-resources></ngz-resources>`,
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: null,
        breadcrumbs: [
          { label: 'Resource Library', icon: NAVIGATION_ICON.PLAY_ARROW }
        ]
      }
    })
    .when('/resources-library/swymo-academy', {
      template: `<ngz-resource-library page="${VIDEO_PAGE.SWYMO_ACADEMY}"></ngz-resource-library>`,
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: null,
        breadcrumbs: [
          { label: 'Resource Library', icon: NAVIGATION_ICON.FOLDER_OPEN },
          { label: 'SWYMO Academy', icon: NAVIGATION_ICON.SCHOOL }
        ]
      }
    })
    .when('/resources-library/scan-iq', {
      template: `<ngz-resource-library page="${VIDEO_PAGE.SCAN_IQ}"></ngz-resource-library>`,
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: null,
        breadcrumbs: [
          { label: 'Resource Library', icon: NAVIGATION_ICON.FOLDER_OPEN },
          { label: 'ScanIQ', icon: NAVIGATION_ICON.BAR_CHART }
        ]
      }
    })
    .when('/resources-library/in-body', {
      template: `<ngz-resource-library page="${VIDEO_PAGE.INBODY}"></ngz-resource-library>`,
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: null,
        breadcrumbs: [
          { label: 'Resource Library', icon: NAVIGATION_ICON.FOLDER_OPEN },
          { label: 'InBody', icon: NAVIGATION_ICON.TIMELINE }
        ]
      }
    })
    .when('/resources-library/challenges', {
      template: `<ngz-resource-library page="${VIDEO_PAGE.CHALLENGES}"></ngz-resource-library>`,
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: null,
        breadcrumbs: [
          { label: 'Resource Library', icon: NAVIGATION_ICON.FOLDER_OPEN },
          { label: 'Challenges', icon: NAVIGATION_ICON.EMOJI_EVENTS }
        ]
      }
    })
    .when('/resources-library/nutrition', {
      template: `<ngz-resource-library page="${VIDEO_PAGE.NUTRITION}"></ngz-resource-library>`,
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: null,
        breadcrumbs: [
          { label: 'Resource Library', icon: NAVIGATION_ICON.FOLDER_OPEN },
          { label: 'Nutrition', icon: NAVIGATION_ICON.SPA }
        ]
      }
    })
    .when('/resources-library/in-body-university', {
      template: `<ngz-resource-library page="${VIDEO_PAGE.INBODY_UNIVERSITY}"></ngz-resource-library>`,
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: null,
        breadcrumbs: [
          { label: 'Resource Library', icon: NAVIGATION_ICON.FOLDER_OPEN },
          { label: 'InBody University', icon: NAVIGATION_ICON.AUTO_STORIES }
        ]
      }
    })
    .when('/resources-library/app-video-library', {
      template: `<ngz-resource-library page="${VIDEO_PAGE.APP_VIDEO_LIBRARY}"></ngz-resource-library>`,
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: null,
        breadcrumbs: [
          { label: 'Resource Library', icon: NAVIGATION_ICON.FOLDER_OPEN },
          { label: 'App Video Library', icon: NAVIGATION_ICON.VIDEO_LIBRARY }
        ]
      }
    })
    .when('/resources-library/business-center', {
      template: `<ngz-resource-library page="${VIDEO_PAGE.BUSINESS_CENTER}"></ngz-resource-library>`,
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: null,
        breadcrumbs: [
          { label: 'Resource Library', icon: NAVIGATION_ICON.FOLDER_OPEN },
          { label: 'Business Center', icon: NAVIGATION_ICON.BUSINESS }
        ]
      }
    })
    .when('/training-calendar', {
      template: `<ngz-training-calendar></ngz-training-calendar>`,
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: null,
        breadcrumbs: [
          { label: 'Training Calendar', icon: NAVIGATION_ICON.DATE_RANGE }
        ]
      }
    })
    .when('/account-setup', {
      template: '<ngz-account-setup></ngz-account-setup>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: null,
        breadcrumbs: [
          { label: 'Account Setup', icon: NAVIGATION_ICON.MANAGE_ACCOUNTS }
        ]
      }
    });
}
